import { Controller, useFormContext } from 'react-hook-form';

import { Select } from 'components/DesignSystem/Select';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

const options = [
    { value: 'openai', label: 'Open AI' },
    { value: 'ollama', label: 'Ollama' },
];

export const AiType = () => {
    const methods = useFormContext<FormProps>();

    const value = options.find((item) => item.value === methods.watch('aiType')) ?? null;
    const onChange = (value: { value: string; label: string }) => {
        methods.setValue('aiType', value?.value ?? '', { shouldDirty: true });
    };
    return (
        <Controller
            render={({ field }) => (
                <Select {...field} options={options} onChange={onChange} value={value} label={'AI type'} />
            )}
            name={`aiType`}
            control={methods.control}
        />
    );
};
